export const SAVINGS_TABS = [
    { value: "summary", label: "Resumen" },
    { value: "accounts", label: "Cuentas" },
    { value: "transactions", label: "Movimientos" },
    { value: "goals", label: "Metas" },
    { value: "budgets", label: "Presupuestos" },
];
